import React, { Component } from 'react';
import { Segment, Button, Form, TextArea, Message, Input, Icon, Label } from 'semantic-ui-react';
import { passesFinalValidations } from './validations';

class FinalValidation extends Component {
    performFinalValidations = () => {
        const { nonOfficers, officers, maxRate, maxPayroll, minPayroll, extremeWage } = this.props;

        if (passesFinalValidations(nonOfficers, officers, maxRate, maxPayroll, minPayroll, extremeWage)) {
            this.props.setFinalValidations(true, true);
            this.props.goToNextStep();
        } else {
            this.props.setFinalValidations(false, true, nonOfficers, officers);
        }
    }

    render() {
        const {
            passedFinalValidations,
            finishedWithClassAndWage,
            correctionsFileName,
            correctionsExplanation,
            readOnly,
            applicationId,
            saving
        } = this.props;

        return (
            <div>
                {!finishedWithClassAndWage &&
                    <Segment>
                        <Button
                            content='Click here when you are finished with class & wage'
                            color='green'
                            onClick={this.performFinalValidations}
                        />
                    </Segment>
                }
                {!passedFinalValidations && finishedWithClassAndWage &&
                    <Segment>
                            <Form as='div'>
                                <Message negative>
                                    <Message.Header>There are Fatal errors with class and wage.</Message.Header>
                                    <p>Please correct the errors or provide additional information below and submit for review.</p>
                                </Message>
                                <Form.Field>
                                    <TextArea
                                        autoHeight
                                        placeholder='Enter your explanation here'
                                        rows={3}
                                        value={correctionsExplanation}
                                        onChange={this.props.onCorrectionsExplanationChange}
                                        disabled={readOnly}
                                    />

                                </Form.Field>
                                {(correctionsFileName !== '') && (
                                    <Button as='div' labelPosition='left' className='file-download'>
                                        <Label basic onClick={() => this.props.downloadAttachment(applicationId, 'corrections', correctionsFileName)} target='_blank'>
                                            {correctionsFileName}
                                        </Label>
                                        <Button icon onClick={() => this.props.downloadAttachment(applicationId, 'corrections', correctionsFileName)} target='_blank'>
                                            <Icon name='download' />
                                        </Button>
                                    </Button>
                                )}
                                <Form.Field>
                                    <Input
                                        type='file'
                                        fluid
                                        accept='application/pdf'
                                        id='correctionFormFile'
                                        onChange={this.props.onFileChange}
                                        disabled={readOnly}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Button
                                        content='Submit for review'
                                        color='green'
                                        inverted
                                        onClick={() => this.props.onSubmit('REVIEW', 'CORRECTIONS')}
                                        disabled={readOnly || saving}
                                        loading={saving}
                                    />
                                </Form.Field>
                            </Form>
                    </Segment>
                }
            </div>
        );
    }
}

export default FinalValidation;